export const VIEW_MODES = { PROJECTS: "projects", SCOPES: "scopes" };

export function flattenProjectsToScopeRows(projects = []) {
  return projects.flatMap((project) => {
    // API returns contractor_scopes; fall back to scopes for older payloads.
    const scopes = project.contractor_scopes || project.scopes || [];
    return scopes.map((scope) => ({
      ...scope,
      parentProjectId: project.id,
      parentProjectName: project.name,
      parentProposalId: project.proposal_id,
      parentManagedBy: project.managed_by,
    }));
  });
}

/**
 * Path param for /project/details/:id must be a proposal_id — never project id.
 * Projects view: parent proposal_id, else first nested scope's proposal_id.
 * Scopes view: parent proposal_id (open parent project), else the scope's proposal_id.
 */
export function getDetailsRouteId(item, viewMode = VIEW_MODES.PROJECTS) {
  if (viewMode === VIEW_MODES.SCOPES) {
    return item.parentProposalId ?? item.proposal_id ?? null;
  }

  if (item?.proposal_id) return item.proposal_id;

  const nestedScopes = item?.contractor_scopes || item?.scopes || [];
  return nestedScopes[0]?.proposal_id ?? null;
}

/** Dashboard list path with optional view=scopes|projects query. */
export function getProjectsListPath(view) {
  if (view === VIEW_MODES.SCOPES) {
    return `/dashboard?view=${VIEW_MODES.SCOPES}`;
  }
  return "/dashboard";
}

/**
 * Build project-details URL, always carrying from=projects + view so back
 * navigation can restore the Projects/Scopes toggle.
 */
export function buildProjectDetailsHref(
  routeId,
  { managedBy, projectId, viewMode } = {},
) {
  const qs = new URLSearchParams();
  qs.set("from", "projects");
  if (viewMode) qs.set("view", viewMode);

  if (managedBy === "contractor") {
    qs.set("managed_by", "contractor");
    if (projectId != null) qs.set("project_id", String(projectId));
  }

  return `/project/details/${routeId}?${qs.toString()}`;
}

export function getRowCost(item) {
  return item?.project_cost ?? item?.homeowner_price ?? null;
}

export function getScopeDisplayName(item) {
  return item?.scope_name || item?.name || "-";
}

export function getRowKey(item, viewMode) {
  if (viewMode === VIEW_MODES.SCOPES) {
    return `${item.parentProjectId}-${item.scope_id}`;
  }
  return item.id;
}

export function parseViewMode(value) {
  return value === VIEW_MODES.SCOPES ? VIEW_MODES.SCOPES : VIEW_MODES.PROJECTS;
}
